@if (
  form?.get(controlName).invalid &&
  (form?.get(controlName).dirty || form?.get(controlName).touched)
  ) {
  <div class="validation-message">
    @for (error of errors; track error) {
      <span>
        @if (form.get(controlName).errors[error.condition]) {
          <label id="{{ controlName }}-error" class="error" role="alert" aria-live="polite"
            for="{{ controlName }}">
            <!-- {{error|json}} -->
            <span>{{ error.message | translate }}</span>
          </label>
        }
      </span>
    }
  </div>
}
<div class="clearfix"></div>